import axios from 'axios';
import { baseUrl } from '@/config';

/**
 * rsc API
 * @author Ju
 */
export default {
  /**
   * 자원 단위 목록을 조회한다.
   * @author Ju
   * @return {Array} 자원 단위 리스트
   */
  getUnits() {
    return axios.get(`${baseUrl}/common/resource/get-resource-units.do`);
  },

  /**
   * 자원 단위 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 구분 리스트
   * @param {Object}
   */
  getRsctypeList(params) {
    return axios.post(`${baseUrl}/common/resource/get-rsctype-list.do`, params);
  },

  /**
   * 자원 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 리스트
   * @param {Object}
   */
  getRscList(params) {
    return axios.post(`${baseUrl}/common/resource/get-rsc-list.do`, params);
  },

  /**
   * 수집 방식에 대한 수집 설정 구분 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 리스트
   * @param {Object}
   */
  getRscGetdataTypeList(rscGetmethodId) {
    return axios.get(`${baseUrl}/common/resource/get-rsc-getdata-type-list.do`, { params: { rscGetmethodId } });
  },

  /**
   * 수집 설정 구분에 대한 수집 설정 목록을 조회한다.
   * @author najongdang
   * @return {Array} 자원 리스트
   * @param {Object}
   */
  getRscGetdataSourceList(rscGetmethodId, rscGetdataTypeId) {
    return axios.get(`${baseUrl}/common/resource/get-rsc-getdata-source-list.do`, { params: { rscGetmethodId, rscGetdataTypeId } });
  },
};



// WEBPACK FOOTER //
// ./src/api/model/rsc.js